export default "__VITE_ASSET__BemHvBH9__"